import { countryCurrency } from "constants/welcomeBonus";

export const getUserCurrency = (user, currentCountry) => {
  if (user?.currency) {
    return user.currency;
  }

  return countryCurrency[currentCountry] || "USD";
};
